export const titleStyle = {
    paddingTop: 8,
    marginBottom: 1,
    marginLeft: 2,
};

export const subTitleStyle = {
    fontSize: '0.75rem',
    fontStyle: 'italic',
    marginTop: 1,
    marginLeft: 2,
    marginBottom: 3,
};

export const ulStyle = {
    fontSize: '0.85rem',
    marginLeft: '2rem',
    padding: 2,
    paddingRight: '2rem',
    lineHeight: '1.75',
};

export const CheckBoxLiStyle = { p: '4px', m: 0 };

export const CheckBoxLiTextStyle = { fontSize: '0.80em', lineHeight: 1.5 };

export const CheckBoxListStyle = { m: 2 };

export const sideBarStyle = { m: 3, mt: 8, fontSize: '0.75rem', lineHeight: '2' };

export const sidebarItemStyle = {
    fontSize: '0.75rem',
    textDecoration: 'none',
    color: 'inherit',
};

// Inline styles for hover effect
export const sidebarItemSX = {
    color: 'inherit',
    '&:hover': {
        textDecoration: 'underline',
        fontWeight: 'bold !important',
        cursor: 'pointer',
    },
};
